// @flow

//
// React
//
import React, { type Node } from 'react';

//
// Formatter
//
import {
    createDateCellRenderer,
} from '../../../trix-web-components-table';

const createDocumentDateTableColumn = (cfg: any): any => {
    return {
        align: 'left',
        flex: false,
        width: 150,

        renderCell: createDateCellRenderer(cfg)
    }
}
export default createDocumentDateTableColumn;